const hasServerError = (errorCode) =>
  errorCode && [400, 401, 403, 500].includes(errorCode);

export default hasServerError;
